import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  refresh = new Subject();
  onClear = new Subject();

  setSearchInputValueSubject = new Subject();
  autoFocus = new BehaviorSubject<boolean>(false);

  private scannedSearch = new Subject<string>();
  private typedSearch = new Subject<string>();

  onScanned(value: string): void {
    this.scannedSearch.next(value);
  }

  onTyped(value: string): void {
    this.typedSearch.next(value);
  }

  onCleared(): void {
    this.typedSearch.next('');
  }

  scanned(): Observable<string> {
    return this.scannedSearch.asObservable();
  }

  typed(): Observable<string> {
    return this.typedSearch.asObservable();
  }

  setSearchInputValue(value: string) {
    this.setSearchInputValueSubject.next(value);
  }

  updateAutoFocus(value: boolean) {
    this.autoFocus.next(value);
  }

  onRefresh() {
    this.refresh.next(true);
  }

  clear() {
    this.onClear.next('');
  }
}
